export default __webpack_public_path__ + "static/media/CircularStd-Regular.ce173167.ttf";